/* eslint-disable react/react-in-jsx-scope */
import style from './disabledOverlay.module.css'

export default function DisabledOverlay({overlayStyle})  {
    return (   
        <div style={overlayStyle} className={style.container}/>
    );
};